import { useQuery, useLazyQuery } from '@apollo/client'
import { getQuestions, getChartReport } from 'app/livbrite/services/community'
import { PRODUCT_SELECTOR_CODE } from 'app/livbrite/resources/constants'
export interface DataSet {
  label: string
  data: number[]
  backgroundColor: string[]
  borderColor?: string[]
  borderWidth: number
}

export interface ChartData {
  labels: string[]
  datasets: DataSet[]
}
interface Question {
  id: number
  title: string
}

interface QuestionsData {
  chartQuestions: {
    questions?: Question[]
  }
}

interface QuestionsVars {
  code: string
}

interface ChartReportVars {
  code: string
  question_id: number
  community_id?: number
  email?: string
  name?: string
  template_code?: string
  json?: boolean
  date_range?: string
}

export interface ChartQuestionOption {
  option_id: number
  option_label: string
  parent_id: number
  parent_label: string
  recommendation: string
  selected_by: number
}

interface ChartReport {
  chartReport: ReportData
}

export interface ReportData {
  url: string
  title: string
  answered_by: number
  display_type: string
  question_options: ChartQuestionOption[]
  json: string
}

export const useReports = () => {
  const { loading: reportsLoading, data: questionsData } = useQuery<QuestionsData, QuestionsVars>(getQuestions, {
    fetchPolicy: 'no-cache',
    variables: {
      code: PRODUCT_SELECTOR_CODE.SURVEY
    }
  })

  const reportsList = questionsData?.chartQuestions.questions

  return {
    reportsList,
    reportsLoading
  }
}

export const useReportDetail = () => {
  const [getReport, { loading: reportLoading, data: reportData }] = useLazyQuery<ChartReport, ChartReportVars>(getChartReport, {
    fetchPolicy: 'no-cache'
  })

  const report = reportData?.chartReport

  return {
    getReport,
    report,
    reportLoading
  }
}

export const respondPercentage = (quantity: number, total: number) => {
  return Math.round(quantity * 100 / total)
}
